module.exports = __webpack_public_path__ + "img/icon-warning.ee988f2b.svg";